/**
 * Punto de entrada del cliente web PWA de FinVoz.
 */

import "./styles.css";
import { FinVozApp } from "./app.js";

const app = new FinVozApp();

// Registrar Service Worker para funcionamiento offline (FR-SYNC-8)
if ("serviceWorker" in navigator && window.location.protocol.startsWith("http")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("Service Worker registrado con éxito:", reg.scope);
      })
      .catch((err) => {
        console.warn("Fallo al registrar Service Worker:", err);
      });
  });
}

// Iniciar aplicación
app.init().catch((err) => {
  console.error("Error crítico al inicializar FinVoz:", err);
  const appEl = document.getElementById("app");
  if (appEl) {
    appEl.textContent = "";
    const container = document.createElement("div");
    container.style.cssText = "padding: 32px; text-align: center; color: var(--danger);";
    const h2 = document.createElement("h2");
    h2.textContent = "Error al iniciar FinVoz";
    const p = document.createElement("p");
    p.style.cssText = "margin-top: 8px;";
    p.textContent = (err as Error).message;
    container.appendChild(h2);
    container.appendChild(p);
    appEl.appendChild(container);
  }
});
